<div class="confirm-dialog">

  <div class="dialog-header">
    <div class="dialog-icon">
      <i class="bi bi-exclamation-triangle-fill"></i>
    </div>

    <div class="dialog-title">
      <h2>Set as Default {{ data.type === 'configuration' ? 'Configuration' : 'Ruleset' }}?</h2>
      <p>
        This action will replace the current default {{ data.type === 'configuration' ? 'configuration' : 'ruleset' }} for your organization.
      </p>
    </div>
  </div>

  <div class="dialog-body">
    <div class="info-box">
      <i class="bi bi-info-circle"></i>

      <span *ngIf="data.type === 'configuration'">
        Future assessments without an explicitly assigned configuration will
        automatically use this default configuration.
      </span>

      <span *ngIf="data.type === 'ruleset'">
        Future assessments without an explicitly assigned ruleset will
        automatically use this default ruleset.
      </span>
    </div>

    <p class="confirmation-text">
      Are you sure you want to continue?
    </p>
  </div>

  <div class="dialog-actions">
    <button
      type="button"
      class="btn-cancel"
      (click)="cancel()">
      Cancel
    </button>

    <button
      type="button"
      class="btn-add"
      (click)="confirm()">
      Set as Default
    </button>
  </div>

</div>